import { render, staticRenderFns } from "./sales-history.vue?vue&type=template&id=07e4c9c4&scoped=true&"
import script from "./sales-history.vue?vue&type=script&lang=js&"
export * from "./sales-history.vue?vue&type=script&lang=js&"
import style0 from "./sales-history.vue?vue&type=style&index=0&id=07e4c9c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e4c9c4",
  null
  
)

export default component.exports